import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../Components/Loading';
import EmptyVisualization from '../../Components/EmptyVisualization';
import WorldChoroplethMap from '../../Components/Charts/WorldChoroplethMap';

const WorldMap = ({ mapData, handleRetry }) => {
  const worldMapIsLoading = (mapData.loading || !mapData.firstLoadComplete);
  const worldMapIsEmpty = (!mapData.loading && mapData.dataIsEmpty);
  const worldMapHasError = !!mapData.error;

  return (
    <React.Fragment>
      {worldMapIsLoading && <Loading /> }

      {(worldMapIsEmpty || worldMapHasError) &&
        <EmptyVisualization
          isError={worldMapHasError}
          handleRetry={handleRetry}
        >
          <WorldChoroplethMap visualizationData={mapData.visualizationData} />
        </EmptyVisualization>
      }

      {!worldMapIsLoading && !worldMapIsEmpty && !worldMapHasError &&
        <WorldChoroplethMap visualizationData={mapData.visualizationData} />
      }
    </React.Fragment>
  );
};

WorldMap.propTypes = {
  mapData: PropTypes.shape({}).isRequired,
  handleRetry: PropTypes.func.isRequired,
};

export default React.memo(WorldMap);



// WEBPACK FOOTER //
// ./src/views/Pages/Dashboard/Worldmap.js